import { render } from "./PreLoader.vue?vue&type=template&id=2ef782ce"
import script from "./PreLoader.vue?vue&type=script&lang=js"
export * from "./PreLoader.vue?vue&type=script&lang=js"

import "./PreLoader.vue?vue&type=style&index=0&id=2ef782ce&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__